export var Paths;

(function (Paths) {
  Paths["List"] = "/film_review_questions";
})(Paths || (Paths = {}));